var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { blue20opacity15, blue50, blue60 } from '../../../colors/blue';
import { gray80 } from '../../../colors/gray';
import { neutral60opacity05, neutral60opacity10, neutral60opacity20 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
import { listStyles } from '../components/MuiListItem';
import { checkbox } from './checkbox';
import { inputText } from './inputText';
export var grid = {
    '.ag-compact-size .ag-body-viewport': {
        overflowY: 'overlay',
        width: 'calc(100% - 12px)', // 100% - 12px for scrollbar
    },
    '.ag-theme-alpine': __assign(__assign(__assign({ '--ag-header-height': rem(34), '--ag-row-height': rem(34), '--ag-font-size': rem(13), '--ag-icon-size': rem(16), '--ag-foreground-color': gray80, '--ag-border-color': 'transparent', '--ag-background-color': 'transparent', '--ag-header-background-color': 'transparent', '--ag-row-border-color': 'transparent', '--ag-row-border-bottom-color': neutral60opacity10, '--ag-row-hover-color': listStyles.hover.backgroundColor, '--ag-odd-row-background-color': 'transparent', '--ag-selected-row-background-color': listStyles.selected.backgroundColor, '--ag-range-selection-border-color': 'transparent', '--yds-ag-cell-edit-border-color': blue60, '&.ag-compact-size, & .ag-compact-size': {
            '--ag-row-height': rem(68),
            '--ag-header-height': '0px',
        }, '& .ag-root-wrapper': {
            fontFamily: 'Inter',
            fontSize: '0.775rem',
        }, '& .ag-header': {
            marginBottom: rem(8),
        }, '& .ag-header-row': {
            borderBottom: "".concat(rem(1), " solid ").concat(neutral60opacity20),
            fontWeight: 600,
        }, '& .ag-header-cell': {
            padding: "0 ".concat(rem(12)),
        }, '& .ag-header-cell-sortable': {
            '&:hover': {
                color: blue50,
            },
        }, '& .ag-body-viewport': {
            padding: 0,
        }, '& .ag-header-group-cell': {
            paddingInline: rem(14),
        }, '& .ag-pinned-left-cols-container > .ag-row-position-absolute': {
            borderInlineEnd: "".concat(rem(1), " solid"),
            borderInlineEndColor: neutral60opacity10,
        }, '& .ag-pinned-right-cols-container > .ag-row-position-absolute': {
            borderInlineStart: "".concat(rem(1), " solid"),
            borderInlineStartColor: neutral60opacity10,
        }, '& .ag-full-width-row .ag-body-viewport': {
            padding: 0,
        }, '& .ag-row': {
            borderBottomColor: 'var(--ag-row-border-bottom-color)',
        }, '& .ag-row-focus': {
            '--ag-row-border-color': listStyles.focused.outlineColor,
            // Focus is displayed only as a frame around the row
            outline: "".concat(rem(1), " solid var(--ag-row-border-color)"),
            outlineOffset: rem(-1),
            '&.ag-full-width-focus': {
                background: 'none',
                userSelect: 'text',
                '--ag-row-border-bottom-color': 'transparent',
                '--ag-row-border-color': 'transparent',
            },
        }, '& .ag-row-hover': {
            '&.ag-full-width-row': {
                background: 'none',
                '--ag-row-border-bottom-color': 'transparent',
                '--ag-row-border-color': 'transparent',
            },
            // In v28+ bg color applied to before elements...
            '&.ag-row-selected::before': {
                backgroundColor: listStyles.selectedHover.backgroundColor,
                backgroundImage: 'none',
            },
        }, '& .ag-cell': {
            lineHeight: 'var(--ag-row-height)',
            padding: "0 ".concat(rem(12)),
        }, '& .ag-icon.ag-icon-filter': {
            width: rem(10),
            height: rem(10),
            backgroundSize: 'contain',
            backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSIjMTA2RUNDIj48cGF0aCBkPSJNNy42NTIgMkgwbDcgNi4yNjF2Ni45NTZsMi0xLjM5MVY4LjI2MWw3LTYuMjE4TDcuNjUyIDJ6Ij48L3BhdGg+PC9zdmc+)',
        }, '& .ag-icon.ag-icon-asc, .ag-icon.ag-icon-desc': {
            width: rem(9),
            height: rem(9),
            backgroundSize: 'contain',
            backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4IDgiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0iIzEwNkVDQyIgPjxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoOHY4SDB6Ij48L3BhdGg+PHBhdGggZD0iTS43IDQuMUwwIDMuMjcyIDMuNDk0IDAgNyAzLjI3MmwtLjcuODI4LTIuODA2LTIuNTkzeiI+PC9wYXRoPjxwYXRoIGQ9Ik0zIDFoMXY3SDN6Ij48L3BhdGg+PC9zdmc+)',
        }, '& .ag-icon.ag-icon-desc': {
            transform: 'rotate(180deg)',
        }, '& .ag-icon.ag-icon-filter::before, .ag-icon.ag-icon-asc::before, .ag-icon.ag-icon-desc::before': {
            content: "''",
        }, '& [class*=MuiListItemSecondaryAction-root]': {
            alignItems: 'center',
            display: 'flex',
            height: rem(32),
            position: 'relative',
            right: 0,
            transform: 'none',
        }, 
        // variants
        '&.yds-grid-no-separator': {
            '--ag-row-border-color': 'transparent',
            '--ag-row-border-bottom-color': 'transparent',
        }, '&.yds-grid-dense': {
            '--ag-header-height': rem(28),
            '--ag-row-height': rem(28),
            '& .ag-row': {
                fontSize: '0.7775rem',
            },
            '& .ag-cell': {
                lineHeight: rem(26),
            },
        }, '&.yds-grid-striped': {
            '--ag-row-border-color': 'transparent',
            '--ag-row-border-bottom-color': 'transparent',
            '--ag-odd-row-background-color': neutral60opacity05,
        }, '&.yds-grid-no-selection': {
            '--ag-row-hover-color': 'transparent',
            '--ag-range-selection-border-color': 'transparent',
            '& .ag-row-focus': {
                '--ag-row-border-color': 'transparent',
                '--ag-row-border-bottom-color': 'inherit',
                backgroundColor: 'inherit',
            },
        }, '&.yds-grid-cell-selection': {
            '--ag-row-hover-color': 'transparent',
            '--ag-range-selection-border-color': blue60,
            '& .ag-row-focus': {
                '--ag-row-border-color': 'transparent',
                '--ag-row-border-bottom-color': 'inherit',
                backgroundColor: 'transparent',
            },
            '& .ag-cell:hover:not(.ag-cell-focus)': {
                backgroundColor: neutral60opacity10,
            },
            '& .ag-cell-focus': {
                backgroundColor: blue20opacity15,
            },
        } }, checkbox), inputText), { '& .ag-popup': {
            '& *:not(.ag-react-container *)': {
                backgroundColor: '#f8f8f8',
            },
        }, '.ag-selection-checkbox': {
            visibility: 'hidden',
        }, '.ag-row-focus .ag-selection-checkbox, .ag-row-hover .ag-selection-checkbox, .ag-show-checkboxes .ag-selection-checkbox': {
            visibility: 'visible !important',
        } }),
    '.action-renderer': {
        padding: "0 ".concat(rem(12)),
        transform: "translateX(".concat(rem(-12), ")"),
        width: "calc(100% + 2 * ".concat(rem(12), ")"),
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        '& > *': {
            flexShrink: 0,
        },
    },
    '.action-renderer.hover-only': {
        display: 'none',
    },
    '.ag-row-hover .action-renderer.hover-only, .ag-row-focus .action-renderer.hover-only': {
        display: 'flex',
    },
    '.errorStatus-renderer, .switch-renderer': {
        display: 'flex',
        alignItems: 'center',
        gap: rem(4),
        height: '100%',
    },
    '.switch-renderer': {
        minWidth: 'min-content',
        gap: rem(0),
    },
    '.errorStatus-renderer > svg': {
        marginInlineEnd: rem(4),
    },
    '.chip-array-renderer': {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        gap: rem(6),
        lineHeight: '1.5',
    },
    '.pie-chart-renderer': {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        svg: {
            position: 'absolute',
        },
        circle: {
            transition: 'stroke-dashoffset 0.35s',
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
        },
        'div.label': {
            fontWeight: 'bold',
        },
    },
    '.slider-renderer': {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        gap: rem(16),
    },
    '.slider-renderer.reversed': {
        flexDirection: 'row-reverse',
    },
    /* -- CELL EDITORS STYLES -- */
    // DIsable inline error messages
    "[class*='yds-'] .MuiFormHelperText-root.Mui-error": {
        display: 'none',
    },
    // SELECT EDITOR
    '.yds-custom-cell-edit-select.yds-custom-cell-edit-select': {
        height: '100% !important',
        width: '100%',
        borderRadius: rem(0),
    },
    // DATE PICKER EDITOR + TEXT FIELD EDITOR
    '.yds-cell-edit-date-picker.yds-cell-edit-date-picker': {
        height: '100% !important',
        '& > div > div': {
            // To override the default height of the input (30px)
            width: '100%',
            height: 'calc(100% - 2px) !important',
            top: '2px',
            borderRadius: '0px',
            // Color definied inside
            outline: '2px solid var(--yds-ag-cell-edit-border-color, blue)',
            outlineOffset: '-2px',
        },
        '& input': {
            boxSizing: 'border-box',
        },
        '& fieldset': {
            border: 'none',
        },
    },
    '.yds-custom-text-edit.yds-custom-text-edit, .yds-cell-edit-time-picker.yds-cell-edit-time-picker': {
        height: '100% !important',
        '& > div': {
            // To override the default height of the input (30px)
            width: '100%',
            height: '100% !important',
            borderRadius: rem(0),
            // Color definied inside
            outline: "".concat(rem(2), " solid var(--yds-ag-cell-edit-border-color, blue)"),
            outlineOffset: rem(-2),
        },
        '& input': {
            boxSizing: 'border-box',
        },
        '& fieldset': {
            border: 'none',
        },
    },
    '.SnackbarContainer-root--max-content': {
        width: 'max-content !important',
    },
};
